<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="零星项目" prop="small_project_id">
                            <Select v-model="Forms.small_project_id" :disabled="is_select" clearable filterable placeholder="零星项目" @on-change="projectChange">
                                <Option v-for="(item,index) in projectList" :key="index" :value="item.small_project_id">{{item.customer_name ? item.name + '（' + item.customer_name + '）' : item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="关联维保记录" prop="maintain_id">
                            <Select v-model="Forms.maintain_id" clearable filterable placeholder="关联维保记录(必选)" class="width-100" @on-change="changeMaintain">
                                <Option v-for="(item,index) in maintainList" :key="index" :value="item.maintain_id">{{item.title}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="收款类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable placeholder="收款类型" class="width-100">
                                <Option v-for="(item,index) in typeList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="不含税金额" prop="money">
                            <Input v-model="Forms.money" type="number" clearable placeholder="如：10000" @on-blur="calcTrueMoney" />
                            <div v-if="moneyLimit !== null" class="text-font-sm" style="margin-top: 4px; color: #c5c8ce;">该维保记录剩余可收：{{moneyLimit}} 元</div>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="费率" prop="tax_rate">
                            <Input v-model="Forms.tax_rate" type="number" clearable placeholder="0~100" @on-blur="calcTaxMoney" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="税费" prop="tax_money">
                            <Input v-model="Forms.tax_money" type="number" clearable placeholder="" @on-blur="calcTrueMoney" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="含税金额" prop="true_money">
                            <Input v-model="Forms.true_money" type="number" clearable placeholder="" />
                        </FormItem>
                    </Col>
                </Row>
                <Divider orientation="left" class="text-primary">发票信息</Divider>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="是否需要开发票">
                            <RadioGroup v-model="Forms.is_invoice" type="button" button-style="solid">
                                <Radio :label="2">需要</Radio>
                                <Radio :label="1">不需要</Radio>
                            </RadioGroup>
                            <span v-if="Forms.is_invoice === 2">&nbsp;<Button type="primary" ghost @click="getContact">自动获取发票信息</Button></span>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32" v-if="Forms.is_invoice === 2">
                    <Col span="12">
                        <FormItem label="发票抬头" prop="invoice_head">
                            <Input v-model="Forms.invoice_head" clearable placeholder="发票抬头" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票电话" prop="invoice_phone">
                            <Input v-model="Forms.invoice_phone" clearable placeholder="发票电话" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票税号" prop="invoice_tax">
                            <Input v-model="Forms.invoice_tax" clearable placeholder="发票税号" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票地址" prop="invoice_address">
                            <Input v-model="Forms.invoice_address" clearable placeholder="发票地址" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="bank_name">
                            <Input v-model="Forms.bank_name" clearable placeholder="开户银行" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="银行卡号" prop="bank_card">
                            <Input v-model="Forms.bank_card" clearable placeholder="银行卡号" />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getDispersedIncomeConfig, getDispersedIncomeDetail, getMaintainSearchList, saveDispersedIncome} from "@/apis/dispersed";
import {getCustomerInvoice} from "@/apis/customer";

export default {
    name: 'DispersedIncomeCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '零星项目收入',
            isBox : false,
            typeList: [],
            projectList: [],
            maintainList: [],
            is_select: false,
            editOldMoney: 0,

            Forms : {
                income_id: '',
                small_project_id: '',
                maintain_id: '',
                type_id: '',
                money: '',
                tax_rate: '',
                tax_money: '',
                true_money: '',
                is_invoice: 1,
                invoice_head: '',
                invoice_phone: '',
                invoice_tax: '',
                invoice_address: '',
                bank_name: '',
                bank_card: '',
                remark: ''
            },
            Rules : {
                small_project_id: [
                    { required: true, type: 'number',  message: '请选择零星项目', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                maintain_id: [
                    { required: true, type: 'number',  message: '请选择维保记录', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择收款类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                money: [
                    { required: true, type: 'number',  message: '请输入不含税金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ]
            }
        }
    },
    computed: {
        /**
         剩余可收额度 = 维保金额 - 已收金额（编辑时加回本条旧金额）
         **/
        moneyLimit(){
            let item = this.maintainList.find(m => parseInt(m.maintain_id) === parseInt(this.Forms.maintain_id));
            if(!item || !item.money) return null;
            let limit = parseFloat(item.money) - parseFloat(item.collected ?? 0);
            if(this.editOldMoney > 0) limit += this.editOldMoney;
            return Math.round(limit * 100) / 100;
        }
    },
    methods: {
        /**
         功能：费率失焦计算税费 = 不含税金额 × 费率%
         time: 2026/09/13
         **/
        calcTaxMoney(){
            let that = this;
            let money = isNaN(parseFloat(that.Forms.money)) ? 0 : parseFloat(that.Forms.money);
            let tax_rate = isNaN(parseFloat(that.Forms.tax_rate)) ? 0 : parseFloat(that.Forms.tax_rate);
            that.Forms.tax_money = parseFloat(money) * parseFloat(tax_rate) / 100;
            that.calcTrueMoney();
        },
        /**
         功能：计算含税金额 = 不含税金额 + 税费
         time: 2026/09/13
         **/
        calcTrueMoney(){
            let that = this;
            let money = isNaN(parseFloat(that.Forms.money)) ? 0 : parseFloat(that.Forms.money);
            let tax_money = isNaN(parseFloat(that.Forms.tax_money)) ? 0 : parseFloat(that.Forms.tax_money);
            that.Forms.true_money = parseFloat(money) + parseFloat(tax_money);
        },
        /**
         功能：项目手动切换（清空已选维保记录）
         time: 2026/09/13
         **/
        projectChange(){
            let that = this;
            that.Forms.maintain_id = '';
            that.changeProject();
        },
        /**
         功能：加载项目下维保记录
         time: 2026/09/12
         **/
        changeProject(){
            let that = this;
            if(!that.Forms.small_project_id){
                that.maintainList = [];
                return;
            }
            getMaintainSearchList({small_project_id: that.Forms.small_project_id}).then(e=>{
                that.maintainList = e.data ?? [];
            })
        },
        /**
         功能：维保记录切换带入维保金额
         time: 2026/09/12
         **/
        changeMaintain(){
            let that = this;
            let item = that.maintainList.find(m => parseInt(m.maintain_id) === parseInt(that.Forms.maintain_id));
            if(!item) return;
            let limit = that.moneyLimit;
            //带入剩余可收额度
            if(limit <= 0){
                that.$Message.warning({ background: true,duration:3, content: '该维保记录已收满，无剩余可收额度'});
                return;
            }
            that.Forms.money = String(limit);
            //联动刷新税费/含税金额
            that.calcTaxMoney();
        },
        /**
         功能：自动获取发票信息（取维保记录所属项目的客户开票资料）
         time: 2026/09/12
         **/
        getContact(){
            let that = this;
            let maintain = that.maintainList.find(m => parseInt(m.maintain_id) === parseInt(that.Forms.maintain_id));
            let project = maintain ? that.projectList.find(p => parseInt(p.small_project_id) === parseInt(maintain.small_project_id)) : null;
            if(!project || !project.customer_id){
                that.$Message.error({ background: true,duration:3, content: '请先选择维保记录'});
                return;
            }
            getCustomerInvoice(project.customer_id).then(e => {
                let data = e.data;
                that.Forms.invoice_head = data.inv_head ?? '';
                that.Forms.invoice_tax = data.inv_num ?? '';
                that.Forms.invoice_phone = data.inv_phone ?? '';
                that.Forms.invoice_address = data.inv_address ?? '';
                that.Forms.bank_name = data.inv_bank ?? '';
                that.Forms.bank_card = data.inv_bank_card ?? '';
                that.$Message.success({ background: true,duration:3, content: '发票信息已带入'});
            })
        },
        /**
         功能：配置
         time: 2026/09/12
         **/
        GetConfig(){
            let that = this;
            getDispersedIncomeConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.projectList = e.data.projectList ?? [];
            })
        },
        /**
         功能：详情
         time: 2026/09/12
         **/
        GetDetail(income_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedIncomeDetail(income_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'income_id' || v === 'small_project_id' || v === 'maintain_id' || v === 'type_id') {
                        that.Forms[v] = data[v] !== '' && data[v] !== null && data[v] !== 0 ? parseInt(data[v]) : '';
                    }else if(v === 'is_invoice'){
                        //invoice_status: 1不开票 2待开票 3未全额开票 4已开票
                        that.Forms[v] = data.invoice_status && parseInt(data.invoice_status) !== 1 ? 2 : 1;
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
                //记录编辑前的收款金额：已收额度统计含本条，计算剩余额度时需加回
                that.editOldMoney = parseFloat(data.money ?? 0) || 0;
                that.changeProject();
            })
        },
        /**
         功能：添加
         time: 2026/09/12
         **/
        add(small_project_id){
            this.isBox = true;
            this.GetConfig();
            if(small_project_id){
                this.Forms.small_project_id = parseInt(small_project_id);
                this.is_select = true;
                this.changeProject();
            }
        },
        /**
         功能：编辑
         time: 2026/09/12
         **/
        edit(income_id){
            this.isBox = true;
            this.is_select = true;
            this.GetConfig();
            if(income_id) this.GetDetail(income_id);
        },
        /**
         功能：提交
         time: 2026/09/12
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    let param = JSON.parse(JSON.stringify(that.Forms));
                    //额度校验：收款金额不能大于维保记录剩余可收额度
                    let limit = that.moneyLimit;
                    if(limit !== null && parseFloat(param.money) > limit + 0.0001){
                        that.$Message.error({ background: true,duration:3, content: '收款金额超出该维保记录剩余可收额度' + limit + '元'});
                        return;
                    }
                    //是否开票转换为发票状态：1不开票 2待开票
                    param.invoice_status = param.is_invoice === 2 ? 2 : 1;
                    delete param.is_invoice;
                    that.$store.commit('SET_LOADING' , true);
                    saveDispersedIncome(param).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '零星项目收入';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                income_id: '',
                small_project_id: '',
                maintain_id: '',
                type_id: '',
                money: '',
                tax_rate: '',
                tax_money: '',
                true_money: '',
                is_invoice: 1,
                invoice_head: '',
                invoice_phone: '',
                invoice_tax: '',
                invoice_address: '',
                bank_name: '',
                bank_card: '',
                remark: ''
            };
            this.maintainList = [];
            this.is_select = false;
            this.editOldMoney = 0;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
